import React, { useState, useEffect, useRef } from 'react';
import { name, titles } from '../constants';
import Footer from './Footer';
import TypingEffect from './TypingEffect';
import '../App.css'; 
import Profile_Photo from '../assets/Profile_Photo.jpg'; 
import AnalyticsChart from './AnalyticsChart';
import LiquidEther from './LiquidEther';
import TiltedCard from './TiltedCard';

const Home = () => {
    const ref = useRef(0);
    const [text, setText] = useState('');
    const [isNameLoaded, setIsNameLoaded] = useState(false);

    // Typing effect for the name
    useEffect(() => {
        const interval = setInterval(() => {
            if (ref.current < name.length) {
                ref.current++;
                setText((prevText) => prevText + name[ref.current - 1]);
            } else {
                clearInterval(interval);
                setIsNameLoaded(true); // Set flag to start title typing effect
            }
        }, 200);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="relative min-h-screen bg-black">
            {/* LiquidEther Background */}
            <div className="absolute inset-0 z-0">
                <LiquidEther
                    colors={['#5227FF', '#FF9FFC', '#B19EEF']}
                    mouseForce={20}
                    cursorSize={100}
                    isViscous={false}
                    viscous={30}
                    iterationsViscous={32}
                    iterationsPoisson={32}
                    resolution={0.5}
                    isBounce={false}
                    autoDemo={true}
                    autoSpeed={0.5}
                    autoIntensity={2.2}
                    takeoverDuration={0.25}
                    autoResumeDelay={3000}
                    autoRampDuration={0.6}
                />
            </div>
            
            {/* Main Content */}
            <div className="relative z-10">
            
            {/* Compact Analytics Dashboard - Top Right */}
            <div className='fixed top-[90px] right-4 z-50 w-64 hidden lg:block'>
                <AnalyticsChart isCompact={true} />
            </div>

            <div className='hero relative h-[calc(100vh)] flex justify-center items-center text-white' id='hero'>
                <div className='flex flex-col sm:flex-row items-center gap-8 text-center sm:text-left'>
                    {/* Profile Picture with TiltedCard */}
                    <div 
                        className="transition-all duration-1000"
                        style={{ opacity: isNameLoaded ? 1 : 0 }}
                    >
                        <TiltedCard
                            imageSrc={Profile_Photo}
                            altText="Avinash Profile Photo"
                            captionText="Hire Me!"
                            containerHeight="240px"
                            containerWidth="240px"
                            imageHeight="240px"
                            imageWidth="240px"
                            rotateAmplitude={20}
                            scaleOnHover={1.2}
                            showMobileWarning={false}
                            showTooltip={true}
                            displayOverlayContent={true}
                            overlayContent={
                                <div className="w-full h-full flex items-center justify-center">
                                    <p className="text-white text-lg font-semibold backdrop-blur-sm bg-black/30 px-4 py-2 rounded">
                                        Hi, I'm Avinash!
                                    </p>
                                </div>
                            }
                        />
                    </div>
                    {/* Text on the Right Side */}
                    <div className='pt-4 h-auto sm:h-36 backdrop-blur-sm rounded-3xl'>
                        <h1 className='text-4xl sm:text-5xl md:text-6xl font-extrabold mt-2'>
                            Hi, I'm&nbsp;<span className='text-yellow-200 font-extrabold'>{text}</span>
                        </h1>
                        {isNameLoaded && (
                            <div className='mt-3 text-lg sm:text-xl md:text-2xl'>
                                <p>
                                    I'm a <TypingEffect strings={titles} />
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Footer />
            </div>
        </div>
    );
};

export default Home;
